import dayjs from "dayjs";

export const determineHandInDateTime = (params: any[]) => {
  const dateStr = params[0] as string | null; // appointment date
  const option = params[1] as "dayBeforeAfternoon" | "sameDayMorning"; // dropdown value
  const rangeType = params[2] === "end" ? "end" : "start";

  if (!dateStr || !option) return null;

  const base = dayjs(dateStr);

  switch (option) {
    case "dayBeforeAfternoon": {
      const hour = rangeType === "start" ? 16 : 17;
      return base
        .subtract(1, "day")
        .hour(hour)
        .minute(0)
        .second(0)
        .toISOString();
    }

    case "sameDayMorning": {
      const hour = rangeType === "start" ? 7 : 8;
      const minute = rangeType === "start" ? 45 : 0;
      return base.hour(hour).minute(minute).second(0).toISOString();
    }

    default:
      return null;
  }
};
